export const PARAMS_ANIMAL = {
    especie: {
        prefix: "",
        name: ":especie",
        suffix: "s"
    },
    raza: {
        prefix: "raza-",
        name: ":raza",
        suffix: ""
    },
    sexo: {
        prefix: "",
        name: ":sexo",
        suffix: ""
    },
    edad: {
        prefix: "",
        name: ":edad",
        suffix: ""
    },
    tamano: {
        prefix: "",
        name: ":tamano",
        suffix: ""
    },
    permalink: {
        prefix: "",
        name: ":permalink",
        suffix: ""
    },
    pagina: {
        prefix: "pag-",
        name: ":pagina",
        suffix: ""
    },
}

export const routes ={
    buscador:   `${PARAMS_ANIMAL.especie.name}?${PARAMS_ANIMAL.especie.suffix}/${PARAMS_ANIMAL.raza.name}?/${PARAMS_ANIMAL.sexo.name}?/${PARAMS_ANIMAL.edad.name}?/${PARAMS_ANIMAL.tamano.name}?/${PARAMS_ANIMAL.pagina.name}?`,
    buscadorPagina:`${PARAMS_ANIMAL.pagina.name}`,
    animalPermalink:`${PARAMS_ANIMAL.especie.name}/${PARAMS_ANIMAL.permalink.name}`,
}

export const routesPrefix ={
    root : '/adoptar',
}
